import { z } from "zod";

const requiredSelect = (message: string) =>
  z.any().refine(
    (value) => {
      const selected = Array.isArray(value) ? value[0] : value;
      return !!String(selected ?? "").trim();
    },
    { message },
  );

const requiredNumberString = (message: string) =>
  z
    .string()
    .trim()
    .min(1, message)
    .refine((value) => {
      const clean = value.replaceAll(/[^\d.,-]/g, "");
      const lastDot = clean.lastIndexOf(".");
      const lastComma = clean.lastIndexOf(",");
      let normalized: string;
      if (lastComma > lastDot) {
        normalized = clean.replaceAll(".", "").replace(",", ".");
      } else if (lastDot > lastComma) {
        normalized = clean.replaceAll(",", "");
      } else {
        normalized = clean;
      }
      return !Number.isNaN(Number(normalized));
    }, message);

const optionalNumberString = (message: string) =>
  z
    .string()
    .optional()
    .refine((value) => {
      if (!value || !value.trim()) return true;
      const clean = value.replaceAll(/[^\d.,-]/g, "");
      const lastDot = clean.lastIndexOf(".");
      const lastComma = clean.lastIndexOf(",");
      let normalized: string;
      if (lastComma > lastDot) {
        normalized = clean.replaceAll(".", "").replace(",", ".");
      } else if (lastDot > lastComma) {
        normalized = clean.replaceAll(",", "");
      } else {
        normalized = clean;
      }
      return !Number.isNaN(Number(normalized));
    }, message);

export const zonalGrossMarginCreationSchema = z.object({
  idZonaProductiva: requiredSelect("La zona productiva es obligatoria."),
  idGranoProductivo: requiredSelect("El grano es obligatorio."),
  idCampanaProductiva: requiredSelect("La campaña es obligatoria."),
  cotizacionDolar: requiredNumberString("La cotización dólar es obligatoria."),
  precioCereal: requiredNumberString("El precio cereal neto es obligatorio."),
  rindeEstimadoZonal: requiredNumberString(
    "El rinde estimado zonal es obligatorio.",
  ),
  precioAgroquimicos: requiredNumberString("El precio de agroquímicos es obligatorio."),
  precioFertilizantes: requiredNumberString("El precio de fertilizante es obligatorio."),
  precioSemillas: requiredNumberString("El precio de semillas es obligatorio."),
  precioLabores: requiredNumberString("El precio de labores es obligatorio."),
  precioSeguros: requiredNumberString("El precio de seguro es obligatorio."),
  costoImplantacion: requiredNumberString("El costo de implantación es obligatorio."),
  precioAlquiler: optionalNumberString("El precio de alquiler debe ser un número válido."),
  gastoDeCosecha: requiredNumberString("El gasto de cosecha es obligatorio."),
  inversionTotal: requiredNumberString("La inversión total es obligatoria."),
  equilibrio: requiredNumberString("El equilibrio es obligatorio."),
});

export type ZonalGrossMarginCreationForm = z.infer<
  typeof zonalGrossMarginCreationSchema
>;
